import { render, staticRenderFns } from "./RTReportList.vue?vue&type=template&id=74dedd7e"
import script from "./RTReportList.vue?vue&type=script&lang=js"
export * from "./RTReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports